import styled from 'styled-components';

export const CheckboxContainer = styled.div``;

// ============= ============= ============= ============= =============

export const Checkbox = styled.input`
  border: 1px solid #d9d9d9;
  width: 18px;
  border-radius: 4px;
  box-sizing: border-box;
  height: 18px;
  cursor: pointer;
  margin: 0.3rem;
  transform: translateY(4px);
`;
export const MarketingLabel = styled.label``;
